import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between mb-3" }

import { onMounted, reactive, ref } from 'vue';
import { useRolesStore } from '@/store/roles';
import PermissionsDialog from './PermissionsDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Roles',
  setup(__props) {

const rolesStore = useRolesStore();

const headers = [
  { title: 'ID', value: 'id' },
  { title: 'Nombre', value: 'name' },
  { title: '', value: 'actions', sortable: false, align: 'end' },
];

const openCreate = ref(false);
const openEdit   = ref(false);
const openDelete = ref(false);
const permissionsOpen = ref(false);

const saving = ref(false);
const selected = ref<any>(null);

const form = reactive({ name: '', guard_name: '*' });

onMounted(() => {
  rolesStore.fetchRoles();
});

function resetForm() {
  form.name = '';
  form.guard_name = '*';
}

function edit(item: any) {
  selected.value = item;
  form.name = item.name || '';
  form.guard_name = item.guard_name || '*';
  openEdit.value = true;
}

function openPermissions(item: any) {
  selected.value = item;
  permissionsOpen.value = true;
}

function askDelete(item: any) {
  selected.value = item;
  openDelete.value = true;
}

async function saveCreate() {
  try {
    saving.value = true;
    await rolesStore.createRole({ ...form });
    openCreate.value = false;
    resetForm();
  } finally { saving.value = false; }
}

async function saveEdit() {
  if (!selected.value) return;
  try {
    saving.value = true;
    await rolesStore.updateRole(selected.value.id, { ...form });
    openEdit.value = false;
    selected.value = null;
    resetForm();
  } finally { saving.value = false; }
}

async function confirmDelete() {
  if (!selected.value) return;
  try {
    saving.value = true;
    await rolesStore.deleteRole(selected.value.id);
    openDelete.value = false;
    selected.value = null;
  } finally { saving.value = false; }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "mx-2 my-3" }, "Roles", -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openCreate.value = true))
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Crear")
            ])),
            _: 1,
            __: [10]
          })
        ])
      ]),
      _createVNode(_component_v_data_table, {
        headers: headers,
        items: _unref(rolesStore).roles,
        loading: _unref(rolesStore).loading,
        "item-key": "id",
        class: "elevation-1"
      }, {
        "item.actions": _withCtx(({ item }) => [
          _createVNode(_component_v_menu, null, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                icon: "",
                variant: "text"
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("mdi-dots-vertical")
                    ])),
                    _: 1,
                    __: [12]
                  })
                ]),
                _: 2
              }, 1040)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, { density: "compact" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    onClick: ($event: any) => (edit(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("Editar")
                        ])),
                        _: 1,
                        __: [13]
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_v_list_item, {
                    onClick: ($event: any) => (openPermissions(item))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("Permisos")
                        ])),
                        _: 1,
                        __: [14]
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["items", "loading"]),
      _createVNode(_component_v_dialog, {
        modelValue: openCreate.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((openCreate).value = $event)),
        width: "520"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("Crear rol")
                ])),
                _: 1,
                __: [15]
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
                    label: "Nombre"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (openCreate.value = false))
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("Cancelar")
                    ])),
                    _: 1,
                    __: [16]
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    loading: saving.value,
                    onClick: saveCreate
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("Guardar")
                    ])),
                    _: 1,
                    __: [17]
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: openEdit.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((openEdit).value = $event)),
        width: "520"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("Editar rol")
                ])),
                _: 1,
                __: [18]
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.name) = $event)),
                    label: "Nombre"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (openEdit.value = false))
                  }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("Cancelar")
                    ])),
                    _: 1,
                    __: [19]
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    loading: saving.value,
                    onClick: saveEdit
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("Guardar")
                    ])),
                    _: 1,
                    __: [20]
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: openDelete.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((openDelete).value = $event)),
        width: "420"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode("Eliminar rol")
                ])),
                _: 1,
                __: [21]
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[22] || (_cache[22] = _createTextVNode(" ¿Seguro que deseas eliminar el rol ")),
                  _createElementVNode("strong", null, _toDisplayString(selected.value?.name), 1),
                  _cache[23] || (_cache[23] = _createTextVNode("? "))
                ]),
                _: 1,
                __: [22,23]
              }),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (openDelete.value = false))
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("Cancelar")
                    ])),
                    _: 1,
                    __: [24]
                  }),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    loading: saving.value,
                    onClick: confirmDelete
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("Eliminar")
                    ])),
                    _: 1,
                    __: [25]
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (permissionsOpen.value)
        ? (_openBlock(), _createBlock(PermissionsDialog, {
            key: 0,
            role: selected.value!,
            onClose: _cache[9] || (_cache[9] = ($event: any) => (permissionsOpen.value = false))
          }, null, 8, ["role"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})